<div class="container-fluid" id="referNow-mainDIV-container-div" style="height: 700px">
  <div class="row" id="referNow-mainDIV-container-div-row">
    <div class="col-md-8 col-xs-8" id="referNow-mainDIV-container-div-col">
      <div class="designView" id="referNow-mainDIV-container-divDesign">
        <div id="referNow-mainDIV-container-div-reqGen">
          <app-dynamic-form id="referNow-mainDIV-container-DYNAMIC" *ngIf="reqgenModel" [fields]="reqgenModel.fields">
          </app-dynamic-form>
          <div
            class="row"
            id="referNow-mainDIV-container-div-ex-row"
            class="padL16 padB8"
            *ngIf="companyHiringType !== '2'"
          >
            <mat-card appearance="outlined" id="referNow-mainDIV-container-div-ex-matCard" class="col-md-6 col-xs-6">
              <mat-slide-toggle
                id="referNow-mainDIV-container-div-ex-matSlide"
                class="custom-slideToggle"
                [checked]="exInfy"
                (toggleChange)="onToggleChangeExInfy()"
              >
                Is the candidate an ex-Infoscian?
              </mat-slide-toggle>

              <form [formGroup]="exInfyForm" *ngIf="exInfy" id="referNow-mainDIV-container-div-ex-FORM">
                <mat-form-field class="custom-form-field" id="referNow-mainDIV-container-div-ex-form-field">
                  <input
                    id="referNow-mainDIV-container-div-ex-input"
                    matInput
                    [errorStateMatcher]="matcher"
                    placeholder="Employee ID Number"
                    formControlName="exinfoscion"
                    [value]="reqgenModel.exEmployeeNumber"
                    required="exInfy"
                  />
                  <mat-error
                    id="referNow-mainDIV-container-div-ex-FORM-form-error"
                    *ngIf="exInfyForm.get('exinfoscion').hasError('required')"
                  >
                    ID is required
                  </mat-error>
                  <mat-error
                    id="referNow-mainDIV-container-div-ex-FORM-form-error-pattern"
                    *ngIf="exInfyForm.get('exinfoscion').hasError('pattern')"
                  >
                    Please enter only numbers.
                  </mat-error>
                  <mat-error
                    id="referNow-mainDIV-container-div-ex-FORM-form-error-maxLen"
                    *ngIf="exInfyForm.get('exinfoscion').hasError('maxlength')"
                  >
                    Please enter maximum 10 characters.
                  </mat-error>
                  <mat-error
                    id="referNow-mainDIV-container-div-ex-FORM-form-error-minLen"
                    *ngIf="
                      exInfyForm.get('exinfoscion').hasError('minlength') &&
                      !exInfyForm.get('exinfoscion').hasError('pattern')
                    "
                    >Please enter minimum 4 characters.
                  </mat-error>
                </mat-form-field>
              </form>
            </mat-card>
          </div>
          <div class="row">
            <div style="float: left" class="col-md-6 col-xs-6">
              <mat-form-field class="custom-form-field padL16 padT8">
                <input
                  matInput
                  name="referenceCode"
                  (keypress)="keyPressedAlphabets($event)"
                  [formControl]="referenceCode"
                  placeholder="Reference Code"
                />
                <button
                  matSuffix
                  class="btn btn-sm editButton"
                  style="padding-bottom: 3px"
                  [disabled]="checkRefCode()"
                  (click)="CheckRefDetails()"
                >
                  <span class="">Check</span>
                </button>
                <mat-error *ngIf="referenceCode.hasError('required')"> Reference Code is required. </mat-error>
                <mat-error *ngIf="referenceCode.hasError('pattern')">
                  Please enter a valid Reference Code (ex:ABC-Defgh-01234, ABC-Defgh-01234-2).
                </mat-error>
              </mat-form-field>
              <div *ngIf="referenceCodeError && referenceCode.valid">
                <p class="marL16 errorMsg">
                  Please enter Reference Code that belongs to Company Hiring Type Id {{ companyHiringType }}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <mat-form-field class="custom-form-field col-md-6 col-xs-6 padT8" *ngIf="codeFlag">
                <mat-label>Role/Designation</mat-label>
                <input matInput name="" value="{{ publicationDetails.roleDesignation }}" [readonly]="true" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-6 padL32">
              <mat-form-field class="custom-form-field padT8" *ngIf="codeFlag">
                <mat-label>Source Type</mat-label>
                <input matInput name="" value="{{ publicationDetails.sourceType }}" [readonly]="true" />
              </mat-form-field>
            </div>
            <div class="col-md-6 col-xs-6">
              <mat-form-field class="custom-form-field col-md-6 col-xs-6 padT8" *ngIf="codeFlag">
                <mat-label>Source Name</mat-label>
                <input matInput name="" value="{{ publicationDetails.sourceName }}" [readonly]="true" />
              </mat-form-field>
            </div>
            <div *ngIf="codeFlag" class="padL32 col-md-6 col-xs-6">
              <mat-form-field class="custom-form-field" *ngIf="referalFlag">
                <mat-label>Referral Employee Number</mat-label>
                <input matInput name="refereeId" [errorStateMatcher]="matcher" [formControl]="refereeId" />
                <mat-error *ngIf="refereeId.hasError('pattern')"> Please enter only numbers. </mat-error>
                <mat-error *ngIf="refereeId.hasError('required')"> Referee Employee no. is required. </mat-error>
                <mat-error *ngIf="refereeId.hasError('maxlength')"> Please enter maximum 10 characters. </mat-error>
                <mat-error *ngIf="refereeId.hasError('minlength') && !refereeId.hasError('pattern')">
                  Please enter minimum 4 characters.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="custom-form-field" *ngIf="subconReferral">
                <input
                  matInput
                  name="subconId"
                  [errorStateMatcher]="matcher"
                  [formControl]="subconId"
                  placeholder="Subcon Employee Number "
                />
                <mat-error *ngIf="subconId.hasError('required')"> Subcon Employee no. is required. </mat-error>
                <mat-error *ngIf="subconId.hasError('pattern') && companyHiringType === '1'">
                  Please enter 7 digit Subcon Id.
                </mat-error>
                <mat-error *ngIf="subconId.hasError('pattern') && companyHiringType === '4'">
                  Please enter 6-7 digit Subcon Id.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-md-4 col-xs-4">
      <div style="width: 100%">
        <br />
        <app-attach
          (fileOutput)="receiveFileOutput($event)"
          [linkdownload]="true"
          [toggleBtn]="true"
          [label]="label"
          [allowedTypes]="allowedTypes"
          [uploadType]="'single'"
          #attachmentRef
        ></app-attach>
        <BR />
      </div>
    </div>

    <div
      id="referNow-mainDIV-privacy-check-client-submit"
      class="col-md-6 nomarLR container-fluid padL32 marB24 marT16"
    >
      <div class="row" id="referNow-mainDIV-privacy-check-client-submit-row">
        <div class="col-4 padL8" id="referNow-mainDIV-privacy-check-client-submit-div">
          <button
            id="referNow-mainDIV-privacy-check-client-submit-button"
            mat-flat-button
            class="primary-btn btnfullWdth"
            [disabled]="
              dynamicFormComponent?.form?.status === 'INVALID' ||
              fileCheck === false ||
              !codeFlag ||
              (referalFlag &&
                (refereeId.hasError('required') ||
                  refereeId.hasError('minlength') ||
                  refereeId.hasError('pattern') ||
                  refereeId.hasError('maxlength'))) ||
              (subconReferral && (subconId.hasError('required') || subconId.hasError('pattern'))) ||
              publicationDetails.roleDesignation == null ||
              publicationDetails.sourceName == null ||
              publicationDetails.sourceType == null ||
              (exInfy && exInfyForm.get('exinfoscion').hasError('required')) ||
                exInfyForm.get('exinfoscion').hasError('minlength') ||
                exInfyForm.get('exinfoscion').hasError('pattern') ||
                exInfyForm.get('exinfoscion').hasError('maxlength')
            "
            (click)="submit()"
          >
            Create
          </button>
        </div>
        <div class="col-4 padL8" id="referNow-mainDIV-privacy-check-client-submit-div2">
          <button
            id="referNow-mainDIV-privacy-check-client-submit-button-reset"
            mat-flat-button
            class="secondary-btn btnfullWdth"
            (click)="resetForm()"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
